export const selectBeetinqTeamMembers = (state) => state.beetinqTeam.members;
export const selectBeetinqTeamLoading = (state) => state.beetinqTeam.isLoading;
export const selectBeetinqTeamError = (state) => state.beetinqTeam.isError;
export const selectBeetinqTeamMessage = (state) => state.beetinqTeam.message;
export const selectBeetinqTeamCreateLoading = (state) => state.beetinqTeam.createLoading;
export const selectBeetinqTeamCreateError = (state) => state.beetinqTeam.createError;
export const selectBeetinqTeamCreateMessage = (state) => state.beetinqTeam.createMessage;
export const selectBeetinqTeamUpdateLoading = (state) => state.beetinqTeam.updateLoading;
export const selectBeetinqTeamUpdateError = (state) => state.beetinqTeam.updateError;
export const selectBeetinqTeamUpdateMessage = (state) => state.beetinqTeam.updateMessage;
